import React, { useState } from "react";
import "./MyNavbar.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import PhoneIcon from "../../assets/ic_phone.svg";
import WaIcon from "../../assets/ic_wa.svg";
import InstaIcon from "../../assets/ic_insta.svg";
import { removeItemFromLocalStorage } from "../../helpers/util";

function MyNavbar() {
  // const [openForm, setOpenForm] = useState(false);

  // const handleOpenForm = (item = null) => {
  //   setOpenForm(true);
  // };

  // const handleCloseForm = () => {
  //   setOpenForm(false);
  // };
  const handleLogout = () => {
    removeItemFromLocalStorage("jwt");
    window.location.href = "/login";
  };

  const token = localStorage.getItem("jwt");

  return (
    <section id="navbar">
      <Container fluid className="pseudo-navbar">
        <Container className="d-flex justify-content-end">
          <a href="">
            <img
              src={PhoneIcon}
              alt="Phone Icon"
              className="icon d-none d-lg-flex"
            />
          </a>
          <a href="">
            <img
              src={WaIcon}
              alt="Whatsapp Icon"
              className="icon d-none d-lg-flex px-3"
            />
          </a>
          <a href="">
            <img
              src={InstaIcon}
              alt="Instagram Icon"
              className="icon d-none d-lg-flex"
            />
          </a>
        </Container>
      </Container>
      <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary navbar">
        <Container>
          <Navbar.Brand href="/home" className="montserrat-subrayada-bold">
            CMC 16 BATCH
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link
                href="/#home"
                className="poppins-regular navSize nav-item"
              >
                Home
              </Nav.Link>
              <Nav.Link
                href="/#about"
                className="poppins-regular navSize nav-item"
              >
                About
              </Nav.Link>
              <Nav.Link
                href="/#events"
                className="poppins-regular navSize nav-item"
              >
                Events
              </Nav.Link>
              {/* <Nav.Link
                href="/#president"
                className="poppins-regular navSize nav-item"
              >
                President
              </Nav.Link> */}
              <Nav.Link
                href="/#gallery"
                className="poppins-regular navSize nav-item"
              >
                Gallery
              </Nav.Link>
              <Nav.Link
                href="/members"
                className="poppins-regular navSize nav-item"
              >
                Members
              </Nav.Link>
              <Nav.Link
                href="/#memory"
                className="poppins-regular navSize nav-item"
              >
                Loving Memory
              </Nav.Link>
              <Nav.Link
                href="https://online.fliphtml5.com/wuvmw/gunx/"
                className="poppins-regular navSize nav-item"
                target="_blank"
              >
                Pinnilaavu
              </Nav.Link>
              <Nav.Link
                href="/#blog"
                className="poppins-regular navSize nav-item"
              >
                Blog
              </Nav.Link>
              <Nav.Link
                href="/#contact"
                className="poppins-regular navSize nav-item"
              >
                Contact
              </Nav.Link>
              {token && (
                <Button
                  variant="btn-primary btn-login"
                  className="poppins-regular poppins-regular navSize"
                  href="/login"
                  onClick={handleLogout}
                >
                  Logout
                </Button>
             
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </section>
  );
}

export default MyNavbar;
